import Ajax from '../util/ajax';
import { nexaReceiverDeleted } from '../reducers/nexaReceiversSlice';
export function deleteNexaReceiver(id, okCallback, errorCallback) {
    return (dispatch) => {
        const ajax = new Ajax(dispatch);
        const url = '/nexa-receiver/' + id;
        ajax.del(url, undefined, () => {
            dispatch(nexaReceiverDeleted(id));
            okCallback();
        }, () => {
            if (errorCallback != undefined) {
                errorCallback();
            }
        });
    };
}
